import React from "react";
import { Typography, makeStyles, Grid } from "@material-ui/core";
import BenefitCard from "../components/BenefitCard";

const useStyles = makeStyles({
  section: {
    margin: "50px 0px",
    textAlign: "center",
    padding: "0vw 8vw 8vw 8vw"
  },
  title: {
    fontSize: 35,
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    color: "#022233",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center"
  }
});

export default function Benefits() {
  const classes = useStyles();
  const features = [
    {
      title: "با قیمت شما",
      description:
        "در لینگوتاک تعیین قیمت کلاس‌ها با خود شماست، این قابلیت به مدیریت درآمدتون از تدریس خصوصی کمک می‌کنه.‬",
      icon: "feature_1.png"
    },
    {
      title: "از هر مکان ‬",
      description:
        "کلاس‌های لینگوتاک به صورت آنلاین برگزار میشه و این یعنی مکان مناسب برای تدریس رو شما تعیین می‌کنید.‬",
      icon: "feature_2.png"
    },
    {
      title: "در هر زمان‬",
      description:
        "در لینگوتاک فرقی نمی‌کنه کلاس‌هاتون چه ساعتی باشه، هروقت که براتون مناسبه می‌تونید کلاس خصوصی  برگزار کنید.‬",
      icon: "feature_3.png"
    },
    {
      title: "امن و مطمئن‬",
      description:
        "تیم لینگوتاک همیشه کنار شماست تا کلاس‌هاتون بدون هیچ مشکلی برگزار بشه و اگر اتفاقی افتاد به سرعت همه‌چیز رو مرتب کنه.‬",
      icon: "feature_4.png"
    },
    {
      title: "با برنامه خودتون‬",
      description:
        "در لینگوتاک برنامه کلاس‌ها رو شما تعیین کنید تا بتونید از زمان‌های هر هفته بهترین استفاده رو داشته باشید.‬",
      icon: "feature_5.png"
    },
    {
      title: "دانشجوهای بیشتر‬",
      description:
        "لینگوتاک هر روز دانشجوهای بیشتری رو به شما وصل می‌کنه تا کلاس‌های بیشتر و درآمد بالاتری داشته باشید.‬",
      icon: "feature_6.png"
    }
  ];
  return (
    <section>
      <section className={classes.section}>
        <Typography variant="h5" className={classes.title}>
          چرا تدریس با لینگوتاک؟
        </Typography>
        <br /> <br /> <br />
        <Grid container spacing={3} justify="center">
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <BenefitCard {...feature} />
            </Grid>
          ))}
        </Grid>
      </section>
    </section>
  );
}
